import { connect } from 'react-redux'
import React, { Component } from 'react';

class CardPurchaseValidation extends Component {
    render() {
        if (!this.props.isInvalidCreditCardErrorVisible)
            return <div />

        const { ccBrand, ccLastDigits } = this.props
        const brand = ccBrand.charAt(0).toUpperCase() + ccBrand.slice(1)

        return (
            <div className="comp_cardpurchasevalidation">
                <div className="container-left">
                    <img
                        className="alert"
                        src="/assets/images/pagamento/alert-white.svg"
                        alt="erro"
                    />
                </div>
                <div className="container-right">
                    <p className="text-red">
                        Não conseguimos processar o pagamento da sua viagem com o cartão de crédito
                        <b> {brand} final {ccLastDigits}, revise a forma de pagamento e tente finalizar novamente.</b>
                    </p>
                    <br />
                    <p> Listamos os motivos mais comuns para que você possa verificar: </p>
                    <ul className="list">
                        <li>Algum dado inválido (número do cartão, data de vencimento, código de segurança);</li>
                        <li>Bloqueio de segurança pela operadora do cartão;</li>
                        <li>Limite de crédito indisponível no cartao;</li>
                        <li>Limite de transações do cartão virtual;</li>
                        <li>Uso de um cartão de débito (aceitamos apenas crédito).</li>
                    </ul>
                    <p>
                        Se estiver com dúvidas, <b>entre em contato com a operadora do seu cartão</b> para identificar o motivo (geralmente o número de telefone fica no verso do cartão)
                        e <b>finalize a compra novamente.</b>
                    </p>
                </div>
            </div>
        )
    }
}

export default connect(
    state => ({
        isInvalidCreditCardErrorVisible: state.purchase.isInvalidCreditCardErrorVisible,
        ccBrand: state.purchase.invalidCreditCard.brand,
        ccLastDigits: state.purchase.invalidCreditCard.lastDigits
    }), {}
)(CardPurchaseValidation);



// WEBPACK FOOTER //
// ./src/components/purchase/card_purchase_validation/CardPurchaseValidation.jsx